<template>
  <div class="survey-insights-loader-grid">
    <GenderDistributionLoader class="gender-distribution-loader" />
    <LineChartLoader class="gender-by-stage-loader" />
    <RacialDistributionLoader class="race-distribution-loader" />
    <LineChartLoader class="race-by-stage-loader" />
    <GenderAndRaceTableLoader class="gender-and-race-table-loader" />
  </div>
</template>

<script setup>
import GenderDistributionLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/GenderDistributionLoader.vue';
import LineChartLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/LineChartLoader.vue';
import RacialDistributionLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/RacialDistributionLoader.vue';
import GenderAndRaceTableLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/GenderAndRaceTableLoader.vue';
</script>

<style scoped lang="less">
.survey-insights-loader-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 470px minmax(0, 1fr);
  grid-template-rows: 372px 372px auto;
}

.gender-distribution-loader {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

.gender-by-stage-loader {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.race-distribution-loader {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

.race-by-stage-loader {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

.gender-and-race-table-loader {
  grid-column: span 2;
  grid-row: 3 / 4;
  min-height: 228px;
}
</style>
